import 'styles/sass/card.scss';
import type { ReactNode } from 'react';
import { Card as CommonCard } from '../../components/common/Card/Card';

type Card = {
  title: string;
  content: ReactNode;
};

export const CardComponent = ({ title, content }: Card) => {
  return (
    <>
      <div className="wrapper">
        <CommonCard
          className="custom-card"
          id="employees-new"
          title={<h2 className="title">{title}</h2>}
          padding="1.25rem"
        >
          {content}
        </CommonCard>
      </div>
    </>
  );
};
